import { SVGProps, Ref, forwardRef } from "react";

const PencilLineIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 16 16"
    fill="none"
    width="1em"
    height="1em"
    ref={ref}
    aria-label="Pencil Line Icon"
    {...props}
  >
    <title id="Pencil Line Icon">Pencil Line Icon</title>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.667}
      d="M14 14H8.667m-7 .333 3.699-1.422c.237-.091.355-.137.466-.196a1.98 1.98 0 0 0 .28-.183c.1-.077.189-.166.368-.345L14 4.667A1.886 1.886 0 0 0 11.333 2l-7.52 7.52c-.179.18-.269.269-.346.368a2 2 0 0 0-.182.28c-.06.11-.105.23-.196.466l-1.422 3.7Zm0 0 1.372-3.567c.098-.255.147-.383.231-.441a.333.333 0 0 1 .253-.054c.1.02.197.116.39.31l1.507 1.505c.193.194.29.29.309.391a.333.333 0 0 1-.054.253c-.058.084-.186.133-.441.231l-3.567 1.372Z"
    />
  </svg>
);

const ForwardRef = forwardRef(PencilLineIcon);
export default ForwardRef;
